{
  "form": {
    "input_placeholder": "Aggiungi un'attività…",
    "parseWithAi_aria": "Analizza attività con l'AI",
    "parseWithAi_title": "Riordina e imposta la priorità con l'AI",
    "priorityLabel_aria": "Priorità attività",
    "add": "Aggiungi",
    "signInForAi": "Accedi per usare le funzioni AI.",
    "aiUnavailable": "AI non disponibile. Riprova.",
    "saveTo": "Salva in",
    "saveTo_aria": "Salva in {{list}}",
    "saveToSynced_aria": "Salva in {{list}}, {{provider}}",
    "addedTo": "Aggiunto a {{list}}",
    "addedToSynced": "Aggiunto a {{list}} · {{provider}}",
    "show": "Mostra"
  },
  "priority": {
    "Critical": "Critica",
    "High": "Alta",
    "Medium": "Media",
    "Low": "Bassa"
  },
  "item": {
    "edit_aria": "Modifica attività",
    "delete_aria": "Elimina attività",
    "addStep": "Aggiungi un passaggio",
    "addStep_placeholder": "Aggiungi un passaggio…",
    "addStep_aria": "Aggiungi un passaggio a {{task}}",
    "steps_group_aria": "Passaggi di {{task}}",
    "steps_progress_aria": "{{done}} passaggi su {{count}} completati",
    "completeSteps_aria": "{{task}}. Completa anche {{count}} passaggi aperti"
  },
  "list": {
    "title": "Attività",
    "newListFallback": "Nuovo elenco",
    "completedMeta": "{{completed}} di {{total}} completate",
    "deleteConfirm": "Eliminare \"{{name}}\"?",
    "rename_title": "Rinomina",
    "deleteList_title": "Elimina elenco",
    "newListName_placeholder": "Nome elenco…",
    "newList": "Nuovo elenco",
    "done": "Fatto",
    "emptyTitle": "Nessuna attività ancora",
    "emptySubtitle": "Aggiungine una qui sotto per iniziare.",
    "noFilterMatch": "Nessuna attività corrisponde a questo filtro.",
    "createIn": "Crea in",
    "inDestination": "in {{destination}}",
    "createIn_aria": "Crea in {{destination}}",
    "createInAccount_aria": "Crea in {{destination}}, {{email}}",
    "rhemn": "Rhemn",
    "creatingIn": "Creazione in {{destination}}…",
    "createFailed": "Impossibile creare «{{name}}» in {{destination}}.",
    "createLimit": "{{destination}} ha raggiunto il limite di liste.",
    "keepInRhemn": "Tieni in Rhemn"
  },
  "filter": {
    "label": "Filtra",
    "all": "Tutte"
  },
  "voice": {
    "mic_aria": "Aggiungi attività con la voce",
    "mic_title": "Pronuncia le tue attività — ordinate per priorità e momento",
    "stop_aria": "Ferma e ordina le attività",
    "recording": "Registrazione",
    "sorting": "Sto ordinando le attività…",
    "stripTitle": "Attività ascoltate",
    "stripCount": "{{checked}} di {{total}}",
    "discard": "Scarta",
    "addN": "Aggiungi {{count}}",
    "addZero": "Aggiungi",
    "adding": "Aggiunta…",
    "parseFallback": "Impossibile ordinare — le tue parole sono nel campo.",
    "nothingHeard": "Non ho capito — riprova.",
    "micDenied": "Microfono bloccato — consentilo nelle impostazioni.",
    "gateBody": "Pronuncia le attività — ordinate per priorità e blocco di preghiera. Incluso con Pro.",
    "listen_aria": "In ascolto — pronuncia le attività"
  }
}
